module.exports = __webpack_public_path__ + "static/assets/80bb125bef2acb3afd9f14c33fdd3aa6.png";